<template>
  <v-checkbox
    :input-value="value"
    :value="value"
    v-on:change="$emit('input', $event)"
    :model="value"
    :label="label"
    :color="'#00BFB3'"
  ></v-checkbox>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";

Vue.use(Vuelidate);

export default {
  name: "check-box",
  props: {
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: null
    }
  },
  validations() {
    if (this.observations.length) {
      return {
        observations: {
          $each: {
            answer: {
              required
            }
          }
        }
      };
    }
  }
};
</script>
<style>
input[type="checkbox"] {
  opacity: 0;
}
.v-input--selection-controls {
  padding-left: 15px;
  padding-right: 15px;
}
.v-input__slot > .v-label {
  font-weight: 700;
  color: #474747;
  font-size: 21px;
}
@media (max-width: 991px) {
  .v-input--checkbox {
    margin-top: 0px;
  }
  .v-input__slot > .v-label {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fields/Checkbox.vue